import { Pipe, PipeTransform } from '@angular/core';
import type { AppLocale } from '../../services/locale/locale.service';
import { getDocumentSubtypeLabel } from '../../utils/document.utils';

/**
 * A document's type name in the UI language (custom type name, else the backend's
 * `subtype_name` / `subtype_name_da`). Pure: pass the locale signal's value so the pipe re-runs
 * on a language switch.
 *
 * Usage: `doc | documentSubtypeLabel: locale()`
 */
@Pipe({ name: 'documentSubtypeLabel' })
export class DocumentSubtypeLabelPipe implements PipeTransform {
  transform(
    doc: Parameters<typeof getDocumentSubtypeLabel>[0],
    locale: AppLocale | string
  ): string {
    return getDocumentSubtypeLabel(doc, locale);
  }
}
